import { dealService, mapboxService, stateService } from '../../services'
import moment from 'moment';
import { locationStringifyFromCookies } from '../../helpers/location';
import queryString  from 'query-string';
import { serverLocationDetector } from '../../utils/locationDetector';
import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../../components/_App/Layout'))
const Deals = dynamic(() => import('../../templates/Deals'))
const Dealss = dynamic(() => import('../../templates/Dealss'))

export default function DealsPage(props) {
    return (
        <Layout
            isAppleMobile = {props.isAppleMobile}
            seo={{
                description: `Discover deals on cannabis from dispensaries near you on Weedzly. You'll find deals for First Time Patients, Students, Birthdays, & more.`,
                image:'/static/icons/favicon.png',
                title: 'Cannabis Deals Near You | Weedzly',
                url:'https://weedzly.com/deals'
            }}
        >
            <Dealss {...props} />
        </Layout>
    )
}

export async function getServerSideProps(context){
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )
    await serverLocationDetector(context)

    const data = await stateService.getAll('?size=100')

    console.log(data);
     
        await serverLocationDetector(context)
        return {
            props: {
                items: data,
               
                isAppleMobile,
                url: context.req.url.split("?")[0].split("#")[0],
            }
        } 

    return {
        props:{
            isAppleMobile
        }
    }
 
    // let location = (context.query.longitude && context.query.latitude) ? {
    //     longitude: context.query.longitude,
    //     latitude: context.query.latitude,
    //     boundingRadius: context.query.boundingRadius
    // } : _loc
    // location.boundingRadius = context.query.boundingRadius ? context.query.boundingRadius : location.boundingRadius
    // let url = context.req.url.substr(context.req.url.indexOf('?')+1, context.req.url.length)
    // let queryParams = Object.assign({}, queryString.parse(url, {arrayFormat:'bracket'}))
    // let locationText = false
    // let centerObj 
    // let place = 'unknow'
    // if(queryParams.bbox){
    //     locationText = 'Unknow Location'
    //     let center = [(parseFloat(queryParams.bbox[2]) + parseFloat(queryParams.bbox[0]))/2, (parseFloat(queryParams.bbox[3]) + parseFloat(queryParams.bbox[1]))/2]
    //     let {features} = await mapboxService.reverseGeocoding(center[0], center[1], 'types=place')
    //     if(features.length>0){
    //         place= features[0]
    //     }
    //     centerObj={
    //         longitude:  center[0],
    //         latitude:  center[1],
    //     }
    // } else {
     
    //     centerObj = queryString.parse(locationStringifyFromCookies(context))
    //     let {features} = await mapboxService.reverseGeocoding(centerObj.longitude, centerObj.latitude, 'types=place')
    //     if(features.length>0){
    //         place= features[0]
    //     }
    // }
    // try {
    //     if(queryParams.bbox && queryParams.bbox.length != 4){
     
    //         throw new Error('Invalid Location Parameters')
    //     }
    //     if(location || queryParams.bbox){
    //         let deals = await dealService.getNear(
    //             `?date=${moment().format('YYYY-MM-DD')}&${queryString.stringify({size:10, page:0}, {arrayFormat:'bracket'})}&${queryParams.bbox ? queryString.stringify({bbox:queryParams.bbox}, {arrayFormat:'bracket'})  : queryString.stringify(location)}`
    //         )
    //         if(deals.totalData.length === 0){
    //             throw new Error('Not Found')
    //         } 
    //     } else {
    //         throw new Error('No Location')
    //     }
    //     return {
    //         props: {
    //             isAppleMobile,
    //             contextQuery: context.query,
    //             link: `/deals`,
    //             linkAs: `/deals`,
    //             locationParams: queryParams.bbox ? queryString.stringify({bbox:queryParams.bbox}, {arrayFormat:'bracket'}) : locationStringifyFromCookies(context),
    //             locationText: locationText,
    //             centerObj:centerObj,
    //             boundingRadius: location.boundingRadius,
    //             place: place,
    //             items:{
    //                 totalData:[],
    //                 totalCount:[{count:0}]
    //             }
    //         }
    //     }
    // } catch(err){
    //     if(err.message){
    //         err = err.message
    //     }
    //     return {
    //         props: {
    //             isAppleMobile,
    //             success: false,
    //             code: err === 'Internal Server Error' ? 500 : err==='Not Found' ? 404 : err==='No Location' ? 1001 : err==='Invalid Location Parameters' ? 1002 : 500,
    //             contextQuery: context.query,
    //             link: `/deals`,
    //             linkAs: `/deals`,
    //             locationText: locationText,
    //             err: err,
    //             centerObj:centerObj,
    //             place: place,
    //         }
    //     }
    // }

}